import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CesMenuButtonSecondaryComponent } from '../ces-buttons/ces-menu-button-secondary.component';

@Component({
  selector: 'ces-action-menu',
  standalone: true,
  imports: [CesMenuButtonSecondaryComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-action-menu.component.html',
})
export class CesActionMenuComponent {
  readonly menuItems = input.required<MenuItem[]>();
  readonly menuButton = viewChild.required<CesMenuButtonSecondaryComponent>('menuButton');

  toggleMenu(event: MouseEvent): void {
    this.menuButton().menuButtonComponent?.toggleMenu(event);
  }
}
